var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(-4322 -2323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(4316.715 2317.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    transform: "translate(9.034 9.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M10.917,9.359a1.1,1.1,0,1,0-1.559,1.559l6.368,6.368L9.357,23.654a1.1,1.1,0,1,0,1.559,1.559l6.369-6.368,6.368,6.368a1.1,1.1,0,1,0,1.559-1.559l-6.368-6.368,6.368-6.368a1.1,1.1,0,1,0-1.559-1.559l-6.368,6.368L10.917,9.358Z",
    transform: "translate(-9.034 -9.036)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 24,
    height: 24,
    transform: "translate(4322 2323)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/close-modal.ade4b7f71586833e9b121607f52a3f55.svg";
export { ForwardRef as ReactComponent };